import React from 'react';
import {Event} from '../../types/article';
import {SimpleGrid, Text} from '@chakra-ui/react';
import EventCard from '../../components/Articles/EventCard';
import {map, orderBy} from 'lodash';
import MeetUpCard from '../../components/Articles/MeetUpCard';

const RelatedEvents = ({events}: {events: Event[]}) => {
  return (
    <>
      <Text fontSize="xl" fontWeight="bold" mb={4}>
        Related Events
      </Text>
      <SimpleGrid gap="15px" columns={1} textAlign="initial">
        {map(orderBy(events, 'start_date_time'), (event: Event, i) => (
          <MeetUpCard
            key={i}
            //event={{...event, rsvp_status: {status: 'pending', status_value: -1}, is_meetup: false}}
            meet-up={{...event, is_meetup: true}}
          />
        ))}
      </SimpleGrid>
    </>
  );
};

export default RelatedEvents;
